// extracted by mini-css-extract-plugin
export default {"frame":"VariableImage_frame__hekYQ","refresh":"VariableImage_refresh__lD7Sh","corner":"VariableImage_corner__BZHRK"};